import { CalendarCheckIcon } from 'lucide-react'

import { InquiryDateTrendCard } from '@/pages/client-portal/ui/cards/inquiry-date-trend-card/inquiry-date-trend-card'
import { ProcessingTimeCard } from '@/pages/client-portal/ui/cards/processing-time-card/processing-time-card'
import { ProcessingTimeTrendCard } from '@/pages/client-portal/ui/cards/processing-time-trend-card/processing-time-trend-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { cn } from '@/lib/utils'

import { useProcessingTime } from './use-processing-time'

export const ProcessingTime = () => {
  const {
    inquiryIcon,
    inquiryText,
    estimatedTime,
    estimatedTimeUnit,
    inquiryDateTrendData,
    applicationFilingDate,
    processingTimeTrendData,
  } = useProcessingTime()

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<CalendarCheckIcon size={24} />} title="Processing Time" />

      <div className={cn('flex flex-col gap-y-5 lg:grid lg:grid-cols-[400px_auto] lg:grid-rows-2 lg:gap-5', 'mt-5')}>
        <div className={cn('lg:max-w-[400px]')}>
          <ProcessingTimeCard
            inquiryIcon={inquiryIcon}
            inquiryText={inquiryText}
            estimatedTime={estimatedTime}
            estimatedTimeUnit={estimatedTimeUnit}
          />
        </div>
        <div className={cn('min-w-0')}>
          <ProcessingTimeTrendCard processingTimeTrendData={processingTimeTrendData} />
        </div>
        <div className={cn('min-w-0', 'lg:col-span-2')}>
          <InquiryDateTrendCard
            applicationFilingDate={applicationFilingDate}
            inquiryDateTrendData={inquiryDateTrendData}
          />
        </div>
      </div>
    </div>
  )
}
